import React, {useState} from "react";
import SettingOverview from "../compositions/Settings/SettingOverview";
import ButtonSettings from "../compositions/Settings/ButtonSettings";
import FontSettings from "../compositions/Settings/FontSettings";
import MediaSettings from "../compositions/Settings/MediaSettings";
import CategorySettings from "../compositions/Settings/CategorySettings";

const Settings = () => {
    const [settingTab, setSettingTab] = useState<string|null>(null)

    const changeSettingsTab = (tab: string|null) => {
        setSettingTab(tab)
    }

    return (
        <div>
            {settingTab === null && <SettingOverview changeSettingsTab={changeSettingsTab}/>}
            {settingTab === 'button' && <ButtonSettings changeSettingsTab={changeSettingsTab}/>}
            {settingTab === 'fonts' && <FontSettings changeSettingsTab={changeSettingsTab}/>}
            {settingTab === 'media' && <MediaSettings changeSettingsTab={changeSettingsTab}/>}
            {settingTab === 'category' && <CategorySettings changeSettingsTab={changeSettingsTab}/>}
        </div>
    );
};

export default Settings;
